<!--
Copyright 2025 Google LLC. This software is provided as-is, without warranty 
or representation for any use or purpose. Your use of it is subject to your 
agreement with Google.
-->
<div class="response-loader" *ngIf="botResponseLoader">
    <div class="loader"></div>
</div>
<div #botresponse class="botResponse" *ngIf="!botResponseLoader">
    <div class="bot-msg">
        <span><img src="../../assets/bot-icon.svg" alt="bot-avatar" class="bot-logo"></span>
        <div class="bot-answer">
            <markdown [data]="markdownContent" (click)="onCitationClick($event)" id="processedMarkdown" *ngIf="markdownContent"></markdown>
            <div *ngIf="botError">
                <span class="respond-api-errorMsg">An error has occurred. Please rephrase your query or try again
                    later.</span>
            </div>
            <div class="feedback-msg">
                <button (click)="thumbsUp()" [ngClass]="{
                    'feedbackBtnHighlight': showThumbsUpOptions && !botMsg?.feedbackApiError,
                    'feedbackBtn': !showThumbsUpOptions && !botMsg?.feedbackApiError,
                    'feedbackBtnDisabled': botMsg?.feedbackApiError
                  }" [disabled]="botMsg?.feedbackApiError">
                    <img src="../../assets/thumbs-up.png" alt="thumbs-up" class="thumbs-up"
                        *ngIf="!showThumbsUpOptions && !botMsg?.feedbackApiError">
                    <img src="../../assets/thumbs-up-clicked.png" alt="thumbs-up" class="thumbs-up"
                        *ngIf="showThumbsUpOptions && !botMsg?.feedbackApiError">
                    <img src="../../assets/thumbs-up-disabled.png" alt="thumbs-up" class="thumbs-up"
                        *ngIf="botMsg?.feedbackApiError">
                </button>
                <button (click)="thumbsDown()" [ngClass]="showThumbsDownOptions ? 'feedbackBtnHighlight' :'feedbackBtn'"
                    [ngClass]="{
                    'feedbackBtnHighlight': showThumbsDownOptions && !botMsg?.feedbackApiError,
                    'feedbackBtn': !showThumbsDownOptions && !botMsg?.feedbackApiError,
                    'feedbackBtnDisabled': botMsg?.feedbackApiError
                  }" [disabled]="botMsg?.feedbackApiError">
                    <img src="../../assets/thumbs-down.png" alt="thumbs-down" class="thumbs-up"
                        *ngIf="!showThumbsDownOptions && !botMsg?.feedbackApiError">
                    <img src="../../assets/thumbs-down-clicked.png" alt="thumbs-down" class="thumbs-up"
                        *ngIf="showThumbsDownOptions && !botMsg?.feedbackApiError">
                    <img src="../../assets/thumbs-down-disabled.png" alt="thumbs-down" class="thumbs-up"
                        *ngIf="botMsg?.feedbackApiError">
                </button>
            </div>
            <div class="container feedback-container" *ngIf="showFeedbackForm">
                <label class="feedback-label">
                    <span>Why did you choose this rating? <span class="optional-label">(optional)</span></span>
                    <span class="d-flex" style="cursor: pointer;" (click)="closeFeedback()">
                        <mat-icon>close</mat-icon>
                    </span>
                </label>
                <div class="d-flex flex-wrap gap-2" *ngIf="showThumbsUpOptions">
                    <span *ngFor="let option of thumbsUpOptions; let i = index"
                        [ngClass]="option.selected ? 'feedback-option-clicked' : 'feedback-option'">
                        <span class="option-name" (click)="toggleSelectedOptions(option , thumbsUpOptions)">
                            <mat-icon *ngIf="option.selected">done</mat-icon>
                            {{ option.name }}
                        </span>
                    </span>
                </div>
                <div class="d-flex flex-wrap gap-2" *ngIf="showThumbsDownOptions">
                    <span *ngFor="let option of thumbsDownOptions; let i = index"
                        [ngClass]="option.selected ? 'feedback-option-clicked' : 'feedback-option'">
                        <span class="option-name" (click)="toggleSelectedOptions(option, thumbsDownOptions)">
                            <mat-icon *ngIf="option.selected">done</mat-icon>
                            {{ option.name }}
                        </span>
                    </span>
                </div>

                <form [formGroup]="feedbackForm" class="feedbackForm" #feedback>
                    <textarea class="form-control feedback-text" #feedbackComment placeholder={{placeholder}}
                        formControlName="feedbackCtrl" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="4" (keydown)="checkFormValidation()"></textarea>
                    <button type="submit" (click)="submitFeedback(feedbackForm.controls['feedbackCtrl'].value)"
                        [ngClass]="formValidation() ? 'submitBtn' : 'enabledSubmitBtn'" [disabled]="formValidation()"
                        *ngIf="!submitFeedbackLoader">Submit</button>
                    <button class="submitBtnError" *ngIf="submitFeedbackLoader">
                        <div class="submitBtnloader"></div>
                    </button>
                </form>
            </div>
            <div *ngIf="feedbackSent" class="feedback-success">
                <label class="feedback-sent"> Thanks for your feedback</label>
                <span class="d-flex" style="cursor: pointer;" (click)="closeFeedback()">
                    <mat-icon>close</mat-icon>
                </span>
            </div>
            <div class="feedback-error-block" *ngIf="showFeedbackErrorMsg">
                <div class="d-flex gap-4">
                    <img src="../../assets/error-icon.png" alt="asco-thumbnail" class="error-icon">
                    <span class="error-title">{{feedBackErrorMsg}}</span>
                </div>
                <span style="float: right;cursor: pointer;" (click)="closeFeedbackErrorMsg()">
                    <mat-icon>close</mat-icon>
                </span>
            </div>
        </div>
    </div>

    <mat-expansion-panel class="mat-elevation-z0" (opened)="onOpen()" (closed)="onClose()" hideToggle="true"
        *ngIf="botMsg?.related_documents?.length > 0">
        <mat-expansion-panel-header>
            <mat-panel-title> Sources and related content
                <mat-icon class="arrowIcon">{{showArrowUpIcon ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                    }}</mat-icon>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="similar-questions" *ngIf="botMsg?.related_documents?.length > 0">
            <div class="source-cards" *ngFor="let doc of botMsg?.related_documents; let ind = index">
                <div class="source-card" (click)="navigateToGuidelineUrl(doc.guideline_url)">
                    <span matTooltip={{displayToolTipInfo(doc.byName)}} class="docName"> {{doc.byName}} </span>

                    <span class="d-flex w-100 gap-2">
                        <img src="../../assets/asco-thumbnail.png" alt="asco-thumbnail" class="ask-logo">
                        <a href="https://www.ASCOPubs.org" target="_blank" style="text-decoration: none;"
                            class="asco-url">www.ASCOPubs.org</a>
                    </span>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</div>